
import { Vue, Component } from "vue-property-decorator";
import CountTo from "vue-count-to";
import { orderRecordService } from "@/api/payments/order-record";
import { OrderRecordSummaryDto } from "@/api/service-proxies";

@Component({
  components: {
    CountTo,
  },
})
export default class PaymentCount extends Vue {
  orderRecordSummary: OrderRecordSummaryDto = null;
  created() {
    this.fetchData();
  }

  async fetchData() {
    this.orderRecordSummary = await orderRecordService.getOrderRecordSummary();
  }
}
